export const environment = {
  production: false,
  appInsightsConnectionString: 'InstrumentationKey=e85dec22-0bf3-472a-ba09-abfa5caa8edb;IngestionEndpoint=https://norwayeast-0.in.applicationinsights.azure.com/;LiveEndpoint=https://norwayeast.livediagnostics.monitor.azure.com/;ApplicationId=4124440c-1f30-4d44-82c5-85bf89249f49',
  BASE_URL: 'https://ikstagingserver.kuba.no/api/kuba/v1',
  BASE_URL_V2: 'https://ikstagingserver.kuba.no/api',
  BASE_CRM_URL: 'https://crm.kuba.no/nb/',
  BASE_FRONT_URL: 'https://ikstaging.kuba.no',
  BASE_ASSET_PATH: '/assets',
  BASE_STYLES_PATH: '/assets/styles',
  NOTIFICATION_URL: 'https://ikstagingserver.kuba.no/',
  // Cloudflare's always-pass test key. The API must use the matching test secret.
  TURNSTILE_SITE_KEY: '1x00000000000000000000AA'
};
